import Vue from 'vue'
import Router from 'vue-router'
//登录路由
import Login from '@/views/login/login'

import Tab from '@/views/tab/tab'

import Home from '@/router/home/home'
// 测评
import Evaluation from "@/router/evaluation/evaluation"
// 报告
import Report from "@/router/report/report"
// 我的
import My from "@/router/my/my"
// 协议
import Agreement from "@/router/agreement/agreement"
// 空气柜
import AirTank from "@/router/airTank/airTank"
// 课程
import Course from "@/router/course/course"

import PsychologicalHotline from "@/router/psychologicalHotline/psychologicalHotline"
// 消息
import Notification from "@/router/notification/notification"
// 资讯
import Information from "@/router/information/information"

import Event from "@/router/event/event"

Vue.use(Router)

export default new Router({
  mode: 'history', // 使用 history 模式
  routes: [{
      path: '/login',
      name: 'login',
      component: Login
    }, {
      path: '/tab',
      name: 'tab',
      component: Tab,
      redirect: "/home",
      children: [{
        // 首页
        path: '/home',
        name: 'home',
        component: resolve => require(['@/views/home/home.vue'], resolve),
        meta: {
          isLoginAuthority: true // 需要登录权限才能访问
        }
      }, { // 校园动态
        path: '/dynamic',
        name: 'dynamic',
        component: resolve => require(['@/views/dynamic/dynamic.vue'], resolve),
        meta: {
          isLoginAuthority: true // 需要登录权限才能访问
        }
      },{ // 消息分类列表
        path: '/notificationTypeList',
        name: 'notificationTypeList',
        component: resolve => require(['@/views/notification/notificationTypeList.vue'], resolve),
        meta: {
          isLoginAuthority: true // 需要登录权限才能访问
        }
      }, {
        // 个人中心
        path: '/personalCenter',
        name: 'personalCenter',
        component: resolve => require(['@/views/my/personalCenter.vue'], resolve),
        meta: {
          isLoginAuthority: true // 需要登录权限才能访问
        }
      }]
    }, { // 报告列表
      path: '/soulMate',
      name: 'soulMate',
      component: resolve => require(['@/views/soulMate/soulMate.vue'], resolve),
      meta: {
        isLoginAuthority: true // 需要登录权限才能访问
      }
    }, ...Home, ...Evaluation, ...Report, ...My, ...Agreement, ...AirTank, ...Course, ...PsychologicalHotline, ...
    Notification, ...Information, ...Event
  ]
})


// WEBPACK FOOTER //
// ./src/router/index.js